angular.module('lf.desktop')

.directive('miniCartRemoveItemHandler', function (popoversService) {
  return function (scope, el, attrs) {
    var hideTimeout;
    var hideDelay = 5000;
    
    if ('ontouchstart' in window) {
      scope.$on('cart:remove', function () {
        if (el.is(':hidden')) return;
        hideTimeout = setTimeout(function () {
          popoversService.hide('mini-cart-softgoods');
          clearHideTimeout();
        }, hideDelay);
        
        el.on('touchstart.mini-cart-remove-item-handler', clearHideTimeout);
      });
    }
    
    function clearHideTimeout () {
      clearTimeout(hideTimeout);
      el.off('touchstart.mini-cart-remove-item-handler');
    }
    
    scope.$on('$destroy', function () {
      clearHideTimeout();
    });
  }
});
